import { parseISO, isValid, formatISO, add, format } from 'date-fns'
import { es, enUS } from 'date-fns/locale'

export const getReadableDate = (utcDate: string | undefined, language?: string): string => {
  if (!utcDate) {
    return 'Invalid Date'
  }

  const parsedDate = parseISO(utcDate)
  const isValidDate = isValid(parsedDate)

  if (isValidDate) {
    const locale = language === 'es' ? es : enUS
    const formatOptions = { locale }
    const messageDate = format(parsedDate, 'PPP', formatOptions)

    return messageDate
  } else {
    return 'Invalid Date'
  }
}

// this function is only used for testing purposes due to windows environment time-zone setting issues
export const adjustTimeZone = (dateString: string) => {
  const timeZoneOffsetInMinutes = new Date().getTimezoneOffset()

  const parsedDate = parseISO(dateString)
  const adjustedDate = add(parsedDate, { minutes: timeZoneOffsetInMinutes })
  return formatISO(adjustedDate)
}
